import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TurnaLogo from "../TurnaLogo";
import FooterMenu from "./FooterMenu";

const FooterTop = () => {
  return (
    <div className="pt-16">
      <div className="container">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col justify-between gap-8 lg:flex-row">
            <TurnaLogo className="text-primary w-40" />

            <div className="inline-flex items-center gap-6">
              <Link href="https://www.facebook.com/turnacom" target="_blank">
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak["facebook"]}
                  className="text-3xl"
                />
              </Link>
              <Link href="https://twitter.com/turna_com" target="_blank">
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak["twitter-x"]}
                  className="text-3xl"
                />
              </Link>
              <Link href="https://www.instagram.com/turna_com/" target="_blank">
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak["instagram"]}
                  className="text-3xl"
                />
              </Link>
              <Link href="https://www.tiktok.com/@turnacom" target="_blank">
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak["tiktok"]}
                  className="text-3xl"
                />
              </Link>
              <Link
                href="https://www.youtube.com/channel/UCNc36KT-tVbglbzwvwRjy7w/videos"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak["youtube"]}
                  className="text-3xl"
                />
              </Link>
              <Link
                href="https://www.linkedin.com/company/turna.com/"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak["linkedin"]}
                  className="text-3xl"
                />
              </Link>
            </div>
          </div>
          <div className="border-primary-weak border-t"></div>

          <FooterMenu />
        </div>
      </div>
    </div>
  );
};

export default FooterTop;
